import Toast from "components/cms/Toast";
import SectionCard from "components/cms/SectionCard";
import ImageField from "components/cms/ImageField";
import { FieldRow, TextInput } from "components/cms/fields";
import useCmsPage from "hooks/useCmsPage";
import {
  addLogosSection,
  getLogosSection,
  prepareLogos,
  updateLogosSection,
} from "api/logossection";
import { emptyLogos } from "utils/defaults";

const LOGOS_KEYS = ["logosTitle1", "logosTitle2", "logos", "logosHide"];

export default function LogosSection() {
  const {
    form,
    setField,
    frMap,
    loading,
    toast,
    setToast,
    save,
    saving,
    isSectionDirty,
  } = useCmsPage({
    load: getLogosSection,
    create: addLogosSection,
    update: updateLogosSection,
    empty: emptyLogos,
    mapResponse: (res) => res.data?.data,
    prepare: prepareLogos,
  });

  const logos = form.logos || [];

  if (loading) {
    return <p className="mb-5 text-gray-600">Loading Logos…</p>;
  }

  return (
    <>
      <Toast toast={toast} onClose={() => setToast(null)} />
      <SectionCard
        title="Logos"
        hide={form.logosHide}
        hideId="logosHide"
        onHideChange={(value) => setField("logosHide", value)}
        onSave={save}
        saving={saving}
        canSave={isSectionDirty(LOGOS_KEYS)}
      >
        <FieldRow>
          <TextInput
            label="Title line 1"
            path="logosTitle1"
            form={form}
            setField={setField}
            frMap={frMap}
          />
          <TextInput
            label="Title line 2"
            path="logosTitle2"
            form={form}
            setField={setField}
            frMap={frMap}
          />
        </FieldRow>
        <div className="flex flex-wrap gap-2.5">
          {logos.map((logo, index) => (
            <ImageField
              key={`${logo}-${index}`}
              id={`logos.${index}`}
              label={`Logo ${index + 1}`}
              value={logo}
              compact
              onChange={(value) => setField(`logos.${index}`, value)}
            />
          ))}
        </div>
      </SectionCard>
    </>
  );
}
